/**
 * Do not edit directly
 * Generated on Thu, 20 Mar 2025 18:01:35 GMT
 */

module.exports = {
  "borderRadius": {
    "1xsmall": "4px",
    "small": "8px",
    "medium": "12px",
    "large": "24px",
    "circle": "50%",
    "pill": "9999px"
  },
  "breakpoints": {
    "1xsmall": "320px",
    "small": "720px",
    "medium": "1080px",
    "large": "1280px",
    "1xlarge": "1600px"
  },
  "color": {
    "primary": {
      "1xsoftest": "#e6eeff",
      "softest": "#c8d9ff",
      "softer": "#abc6ff",
      "soft": "#364ef7",
      "base": "#0c29d0",
      "strong": "#0a1f9c",
      "stronger": "#0b134a"
    },
    "accent": {
      "1xsoftest": "#c9ffee",
      "softest": "#93f3d4",
      "softer": "#0fe39f",
      "soft": "#0dc78b",
      "base": "#00865b",
      "strong": "#054933",
      "stronger": "#013021"
    },
    "informative": {
      "1xsoftest": "#f3deff",
      "softest": "#f3deff",
      "softer": "#f3deff",
      "soft": "#af38ef",
      "base": "#6a00a3",
      "strong": "#460469",
      "stronger": "#360252"
    },
    "alert": {
      "1xsoftest": "#ffeae5",
      "softest": "#ffc5b9",
      "softer": "#ff9a86",
      "soft": "#e64c2d",
      "base": "#d23718",
      "strong": "#ab351d",
      "stronger": "#6e0000"
    },
    "notice": {
      "1xsoftest": "#fff3d1",
      "softest": "#ffe49b",
      "softer": "#ffce4b",
      "soft": "#edad00",
      "base": "#dda100",
      "strong": "#956e07",
      "stronger": "#6e5001"
    },
    "success": {
      "1xsoftest": "#c9ffee",
      "softest": "#93f3d4",
      "softer": "#0fe39f",
      "soft": "#0dc78b",
      "base": "#00865b",
      "strong": "#054933",
      "stronger": "#013021"
    },
    "neutral": {
      "1xsoftest": "#fafafb",
      "softest": "#f2f3f6",
      "softer": "#e5e8ed",
      "soft": "#b2b9c8",
      "base": "#808aa3",
      "strong": "#4d5c7e",
      "stronger": "#001647"
    }
  },
  "fontFamily": {
    "brand": "Plus Jakarta Sans",
    "secondary": "Plus Jakarta Sans"
  },
  "fontSize": {
    "2xmini": "11px",
    "1xmini": "12px",
    "mini": "13px",
    "3xsmall": "14px",
    "2xsmall": "15px",
    "1xsmall": "16px",
    "small": "17px",
    "medium": "18px",
    "large": "20px",
    "1xlarge": "22px",
    "2xlarge": "24px",
    "3xlarge": "26px",
    "huge": "28px",
    "1xhuge": "32px",
    "2xhuge": "40px",
    "3xhuge": "44px",
    "4xhuge": "48px",
    "5xhuge": "56px",
    "6xhuge": "64px",
    "vast": "72px",
    "1xvast": "80px",
    "2xvast": "88px"
  },
  "fontWeight": {
    "regular": "400",
    "bold": "700",
    "1xbold": "800",
    "light": "300",
    "medium": "500",
    "semibold": "600"
  },
  "graphicAndData": {
    "color": {
      "brand1": {
        "softest": "#e6eeff",
        "softer": "#abc6ff",
        "soft": "#364ef7",
        "base": "#0c29d0",
        "strong": "#0a1f9c",
        "stronger": "#0b134a"
      },
      "brand2": {
        "softest": "#c9ffee",
        "softer": "#93f3d4",
        "soft": "#0fe39f",
        "base": "#0dc78b",
        "strong": "#00865b",
        "stronger": "#086a4c"
      },
      "brand3": {
        "softest": "#f3deff",
        "softer": "#dea5fc",
        "soft": "#9905e8",
        "base": "#6a00a3",
        "strong": "#460469",
        "stronger": "#360252"
      },
      "brand4": {
        "softest": "#ffeae5",
        "softer": "#ff9a86",
        "soft": "#fb775c",
        "base": "#e64c2d",
        "strong": "#d23718",
        "stronger": "#ab351d"
      },
      "brand5": {
        "softest": "#fff3d1",
        "softer": "#ffe49b",
        "soft": "#f7bc1c",
        "base": "#edad00",
        "strong": "#dda100",
        "stronger": "#956e07"
      }
    }
  },
  "letterSpacing": {
    "tight": "0px",
    "regular": "1px",
    "loose": "2px"
  },
  "lineHeight": {
    "3xsmall": "12px",
    "2xsmall": "16px",
    "1xsmall": "20px",
    "small": "24px",
    "medium": "28px",
    "large": "32px",
    "1xlarge": "36px",
    "2xlarge": "40px",
    "3xlarge": "44px",
    "huge": "48px",
    "1xhuge": "52px",
    "2xhuge": "56px",
    "3xhuge": "60px",
    "4xhuge": "64px",
    "5xhuge": "68px",
    "6xhuge": "72px",
    "7xhuge": "76px",
    "vast": "80px",
    "1xvast": "88px",
    "2xvast": "96px",
    "3xvast": "104px"
  },
  "opacity": {
    "base": "0.4",
    "strong": "0.8"
  },
  "shadow": {
    "low": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
    "high": "0px 4px 8px rgba(11, 19, 74, 0.1), 0px 8px 16px rgba(11, 19, 74, 0.08), 0px 16px 32px rgba(11, 19, 74, 0.06)",
    "higher": "0px 8px 16px rgba(11, 19, 74, 0.1), 0px 16px 32px rgba(11, 19, 74, 0.08), 0px 32px 64px rgba(11, 19, 74, 0.06)",
    "diffuse": "0px 0px 16px rgba(11, 19, 74, 0.1), 0px 0px 32px rgba(11, 19, 74, 0.08), 0px 0px 64px rgba(11, 19, 74, 0.06)",
    "mobile": {
      "low": {
        "shadow-color": "#0b134a",
        "shadow-offset": "0px 2px",
        "shadow-radius": "3px",
        "shadow-opacity": "0.16",
        "elevation": "2"
      },
      "high": {
        "shadow-color": "#0b134a",
        "shadow-offset": "0px 4px",
        "shadow-radius": "8px",
        "shadow-opacity": "0.16",
        "elevation": "4"
      },
      "higher": {
        "shadow-color": "#0b134a",
        "shadow-offset": "0px 8px",
        "shadow-radius": "16px",
        "shadow-opacity": "0.24",
        "elevation": "8"
      },
      "diffuse": {
        "shadow-color": "#0b134a",
        "shadow-offset": "0px 0px",
        "shadow-radius": "16px",
        "shadow-opacity": "0.24",
        "elevation": "16"
      }
    }
  },
  "spacing": {
    "inline": {
      "none": "0px",
      "3xsmall": "4px",
      "2xsmall": "8px",
      "1xsmall": "12px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px"
    },
    "inset": {
      "2xsmall": "4px",
      "1xsmall": "8px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px",
      "2xlarge": "48px"
    },
    "squishedInset": {
      "1xsmall": "4px 8px",
      "small": "8px 16px",
      "medium": "12px 24px",
      "large": "16px 32px",
      "1xlarge": "24px 48px"
    },
    "stack": {
      "none": "0px",
      "2xsmall": "4px",
      "1xsmall": "8px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px",
      "2xlarge": "48px",
      "3xlarge": "56px",
      "huge": "64px"
    },
    "stretchedInset": {
      "1xsmall": "8px 4px",
      "small": "16px 8px",
      "medium": "24px 12px",
      "large": "32px 16px",
      "1xlarge": "48px 24px"
    }
  },
  "components": {
    "alert": {
      "variation": {
        "neutral": {
          "background": "#e5e8ed",
          "color": "#001647"
        },
        "primary": {
          "background": "#abc6ff",
          "color": "#0b134a"
        },
        "info": {
          "background": "#f3deff",
          "color": "#360252"
        },
        "success": {
          "background": "#0fe39f",
          "color": "#013021"
        },
        "alert": {
          "background": "#ffce4b",
          "color": "#6e5001"
        },
        "error": {
          "background": "#ff9a86",
          "color": "#6e0000"
        }
      }
    },
    "badge": {
      "svg": {
        "margin": "4px"
      },
      "padding-inline": "8px",
      "font-family": "Plus Jakarta Sans",
      "font-size": "12px",
      "line-height": "16px",
      "font-weight": "700",
      "radius": {
        "default": "4px",
        "pill": "9999px",
        "dot": "50%"
      },
      "variation": {
        "neutral": {
          "background": "#e5e8ed",
          "color": "#001647"
        },
        "primary": {
          "background": "#abc6ff",
          "color": "#0b134a"
        },
        "info": {
          "background": "#f3deff",
          "color": "#360252"
        },
        "success": {
          "background": "#0fe39f",
          "color": "#013021"
        },
        "alert": {
          "background": "#ffce4b",
          "color": "#6e5001"
        },
        "error": {
          "background": "#ff9a86",
          "color": "#6e0000"
        }
      },
      "filter": {
        "disabled": {
          "opacity": "0.4"
        },
        "background": "#f2f3f6",
        "border-color": "#b2b9c8",
        "selected": {
          "background": "#abc6ff",
          "color": "#0c29d0",
          "hover": {
            "background": "#364ef7"
          },
          "active": {
            "color": "#0b134a"
          }
        },
        "hover": {
          "background": "#e5e8ed"
        },
        "active": {
          "background": "#b2b9c8"
        },
        "icon-position": "4px"
      },
      "notification": {
        "variation": {
          "notice": {
            "dot": {
              "background": "#dda100"
            },
            "count": {
              "background": "#ffce4b",
              "color": "#6e5001"
            }
          },
          "alert": {
            "dot": {
              "background": "#d23718"
            },
            "count": {
              "background": "#ff9a86",
              "color": "#6e0000"
            }
          },
          "info": {
            "dot": {
              "background": "#6a00a3"
            },
            "count": {
              "background": "#f3deff",
              "color": "#360252"
            }
          },
          "primary": {
            "dot": {
              "background": "#0c29d0"
            },
            "count": {
              "background": "#abc6ff",
              "color": "#0b134a"
            }
          },
          "neutral": {
            "dot": {
              "background": "#808aa3"
            },
            "count": {
              "background": "#e5e8ed",
              "color": "#001647"
            }
          },
          "accent": {
            "dot": {
              "background": "#00865b"
            },
            "count": {
              "background": "#0fe39f",
              "color": "#013021"
            }
          }
        }
      },
      "mobile": {
        "padding": "4px 8px",
        "icon": {
          "spacing": "4px"
        },
        "filter": {
          "color": "#001647",
          "active": {
            "background": "#e5e8ed"
          },
          "selected": {
            "color": "#0b134a"
          }
        },
        "notification": {
          "spacing": "8px",
          "color": {
            "label": "#001647",
            "dot": "#d23718"
          }
        }
      }
    },
    "button": {
      "default": {
        "font-family": "Plus Jakarta Sans",
        "font-weight": "700",
        "letter-spacing": "0px",
        "size": {
          "medium": {
            "padding": "12px 24px",
            "font-size": "16px",
            "line-height": "24px",
            "icon-position": "12px"
          },
          "small": {
            "padding": "8px 16px",
            "font-size": "14px",
            "line-height": "20px",
            "icon-position": "8px"
          }
        },
        "radius": "32px",
        "box-shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
        "styles": {
          "primary": {
            "rest": {
              "background-color": "#0c29d0",
              "color": "#f2f3f6",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "hover": {
              "background-color": "#0a1f9c",
              "color": "#f2f3f6",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "active": {
              "background-color": "#0b134a",
              "color": "#f2f3f6",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            }
          },
          "accent": {
            "rest": {
              "background-color": "#00865b",
              "color": "#f2f3f6",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "hover": {
              "background-color": "#054933",
              "color": "#f2f3f6",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "active": {
              "background-color": "#013021",
              "color": "#f2f3f6",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            }
          },
          "secondary": {
            "rest": {
              "background-color": "#f2f3f6",
              "color": "#001647",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#b2b9c8"
            },
            "hover": {
              "background-color": "#e5e8ed",
              "color": "#001647",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#b2b9c8"
            },
            "active": {
              "background-color": "#b2b9c8",
              "color": "#001647",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#b2b9c8"
            }
          },
          "danger": {
            "rest": {
              "background-color": "#f2f3f6",
              "color": "#d23718",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#e64c2d"
            },
            "hover": {
              "background-color": "#ff9a86",
              "color": "#ab351d",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#e64c2d"
            },
            "active": {
              "background-color": "#e64c2d",
              "color": "#6e0000",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#e64c2d"
            }
          }
        },
        "disabled": {
          "opacity": "0.4"
        }
      },
      "icon": {
        "size": {
          "height": "48px",
          "width": "48px"
        },
        "radius": "50%",
        "padding": {
          "small": "8px",
          "medium": "12px"
        },
        "styles": {
          "primary": {
            "rest": {
              "background-color": "#f2f3f6",
              "color": "#0c29d0"
            },
            "hover": {
              "background-color": "#e5e8ed",
              "color": "#0c29d0"
            },
            "active": {
              "background-color": "#b2b9c8",
              "color": "#0c29d0"
            }
          },
          "secondary": {
            "rest": {
              "background-color": "#f2f3f6",
              "color": "#001647"
            },
            "hover": {
              "background-color": "#e5e8ed",
              "color": "#001647"
            },
            "active": {
              "background-color": "#b2b9c8",
              "color": "#001647"
            }
          }
        }
      },
      "mobile": {
        "size": {
          "medium": {
            "font-size": "15px",
            "line-height": "24px"
          },
          "small": {
            "font-size": "13px",
            "line-height": "20px"
          }
        },
        "icon": {
          "styles": {
            "primary": {
              "background-color": "#e5e8ed",
              "color": "#0c29d0"
            },
            "secondary": {
              "background-color": "#e5e8ed",
              "color": "#001647"
            }
          }
        },
        "floating": {
          "position": {
            "bottom": "16px",
            "right": "16px",
            "z-index": "99"
          },
          "styles": {
            "primary": {
              "rest": {
                "background-color": "#0c29d0",
                "color": "#f2f3f6"
              },
              "active": {
                "background-color": "#0a1f9c"
              }
            },
            "secondary": {
              "rest": {
                "background-color": "#f2f3f6",
                "color": "#001647"
              },
              "active": {
                "background-color": "#e5e8ed"
              }
            }
          }
        },
        "text": {
          "colors": {
            "rest": "#0c29d0",
            "active": "#0b134a"
          },
          "icon": {
            "spacing": "4px"
          }
        }
      }
    },
    "card": {
      "padding": "24px",
      "border-width": "1px",
      "radius": "12px",
      "background-color": "#f2f3f6",
      "border-color": "#b2b9c8",
      "variation": {
        "primary": "#abc6ff",
        "accent": "#0fe39f",
        "informative": "#f3deff",
        "alert": "#ff9a86",
        "notice": "#ffce4b",
        "success": "#0fe39f",
        "neutral": "#e5e8ed"
      },
      "border": {
        "primary": "#364ef7",
        "accent": "#0dc78b",
        "informative": "#af38ef",
        "alert": "#e64c2d",
        "notice": "#edad00",
        "success": "#0dc78b",
        "neutral": "#b2b9c8"
      },
      "box-shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
      "footer": {
        "border": {
          "width": "1px",
          "color": "#b2b9c8"
        },
        "gap": "16px",
        "padding": {
          "vertical": "16px",
          "horinzontal": "24px"
        }
      }
    },
    "checkbox": {
      "group": {
        "margin": "4px"
      },
      "radius": "4px",
      "spacing": {
        "inline": "4px",
        "vertical": "8px"
      },
      "background-color": {
        "rest": "#f2f3f6",
        "hover": "#e5e8ed",
        "focus": "#e5e8ed",
        "active": "#b2b9c8",
        "selected": "#0c29d0",
        "indeterminate": "#0c29d0",
        "error": "#ff9a86",
        "disabled": "#e5e8ed",
        "readonly": "#e5e8ed",
        "selectedReadonly": "#b2b9c8",
        "selectedDisabled": "#b2b9c8",
        "selectedError": "#d23718",
        "indeterminateDisabled": "#b2b9c8"
      },
      "border-color": {
        "rest": "#b2b9c8",
        "hover": "#b2b9c8",
        "focus": "#4d5c7e",
        "active": "#b2b9c8",
        "selected": "#0c29d0",
        "indeterminate": "#0c29d0",
        "error": "#d23718",
        "disabled": "#b2b9c8",
        "readonly": "#b2b9c8",
        "selectedDisabled": "#b2b9c8",
        "selectedError": "#d23718",
        "indeterminateDisabled": "#b2b9c8"
      },
      "box-shadow": {
        "rest": "none",
        "hover": "0 0 0 8px #e5e8ed",
        "focus": "0 0 0 8px #e5e8ed",
        "active": "0 0 0 8px #e5e8ed"
      },
      "label": {
        "margin": "8px",
        "color": {
          "disabled": "#808aa3",
          "rest": "#001647"
        }
      },
      "checkmark": {
        "radius": "4px",
        "background": "#f2f3f6",
        "border": {
          "width": "2px",
          "color": "#b2b9c8"
        },
        "icon": {
          "color": "#f2f3f6"
        },
        "hover": {
          "background": "#f2f3f6",
          "border": {
            "width": "2px",
            "color": "#b2b9c8"
          }
        }
      },
      "caption": {
        "color": "#4d5c7e"
      }
    },
    "divider": {
      "color": "#b2b9c8",
      "margin-top": "8px",
      "margin-bottom": "8px"
    },
    "drawer": {
      "componentWrapper": {
        "background-color": "#001647A0"
      },
      "closeWrapper": {
        "top": "32px",
        "right": "40px"
      },
      "header": {
        "padding-top": "56px",
        "padding-right": "40px",
        "padding-bottom": "16px",
        "padding-left": "40px"
      },
      "body": {
        "padding-top": "16px",
        "padding-right": "40px",
        "padding-bottom": "32px",
        "padding-left": "40px"
      },
      "container": {
        "border-radius": "12px"
      }
    },
    "dropdown": {
      "content": {
        "width": {
          "default": "280px",
          "subMenu": "240px"
        },
        "padding": "16px",
        "background-color": "#f2f3f6",
        "radius": "12px",
        "shadow": "0px 4px 8px rgba(11, 19, 74, 0.1), 0px 8px 16px rgba(11, 19, 74, 0.08), 0px 16px 32px rgba(11, 19, 74, 0.06)",
        "margin-top": "8px"
      },
      "item": {
        "caption": {
          "color": "#4d5c7e"
        },
        "gap": "16px",
        "background-color": {
          "rest": "#f2f3f6",
          "hover": "#e5e8ed",
          "active": "#b2b9c8"
        },
        "icon": {
          "color": "#4d5c7e"
        },
        "padding": "8px",
        "radius": "4px",
        "color": "#001647",
        "font-family": "Plus Jakarta Sans",
        "font-size": "18px",
        "font-weight": "400",
        "line-height": "28px"
      },
      "divider": {
        "border-color": "#b2b9c8"
      },
      "backButton": {
        "background-color": "#f2f3f6",
        "padding-top": "10px",
        "padding-bottom": "10px",
        "margin-bottom": "8px",
        "color": "#0c29d0",
        "font-family": "Plus Jakarta Sans",
        "font-size": "16px",
        "font-weight": "700",
        "line-height": "24px",
        "icon": {
          "margin-right": "8px"
        }
      },
      "mobile": {
        "padding": "24px",
        "overlay": {
          "opacity": "0.4",
          "background-color": "#001647"
        },
        "dialog": {
          "radius": "24px",
          "background-color": "#f2f3f6"
        },
        "item": {
          "radius": "4px",
          "padding": "8px",
          "background-color": {
            "active": "#e5e8ed"
          }
        }
      }
    },
    "grid": {
      "container": {
        "max-width": "1440px",
        "margin": {
          "xsmall": "16px",
          "small": "32px",
          "medium": "48px",
          "large": "80px",
          "xlarge": "auto"
        }
      },
      "gutter": {
        "small": "16px",
        "medium": "24px"
      }
    },
    "input": {
      "mobile": {
        "font-size": "13px",
        "margin": {
          "label": "4px"
        },
        "font-weight": "700"
      },
      "optionallabel": {
        "color": "#808aa3",
        "font-size": "16px",
        "font-style": "italic",
        "margin": "8px"
      },
      "padding": "16px",
      "margin": "8px",
      "helper-text": {
        "color": "#4d5c7e"
      },
      "border-color": "#b2b9c8",
      "font-family": "Plus Jakarta Sans",
      "font-size": {
        "desktop": "16px",
        "mobile": "15px"
      },
      "line-height": "24px",
      "color": "#001647",
      "background-color": "#f2f3f6",
      "radius": "8px",
      "disabled": {
        "background": "#e5e8ed",
        "border-color": "#e5e8ed"
      },
      "focused": {
        "border-color": "#0c29d0"
      },
      "placeholder": {
        "color": "#808aa3"
      },
      "feedback": {
        "error": {
          "border-color": "#d23718"
        }
      },
      "readOnly": {
        "background": "#e5e8ed"
      },
      "suprefix": {
        "margin": "12px",
        "color": "#4d5c7e",
        "paragraph": {
          "color": "#808aa3",
          "line-height": "24px",
          "font-size": "15px"
        },
        "feedback-icon": {
          "margin-left": "12px",
          "error": {
            "color": "#d23718"
          },
          "valid": {
            "color": "#00865b"
          }
        }
      }
    },
    "link": {
      "font-family": "Plus Jakarta Sans",
      "line-height": "24px",
      "font-weight": "700",
      "font-size": {
        "medium": "16px",
        "large": "18px"
      },
      "letter-spacing": "0px",
      "radius": "4px",
      "icon": {
        "size": "24px",
        "margin": "12px"
      },
      "colors": {
        "rest": "#0c29d0",
        "hover": "#0a1f9c",
        "focus": "#0a1f9c",
        "active": "#0b134a",
        "visited": "#360252"
      }
    },
    "loading": {
      "size": {
        "large": {
          "width": "32px",
          "height": "32px"
        },
        "medium": {
          "width": "24px",
          "height": "24px"
        },
        "small": {
          "width": "16px",
          "height": "16px"
        }
      },
      "variation": {
        "primary": {
          "color": "#0c29d0"
        },
        "danger": {
          "color": "#d23718"
        },
        "info": {
          "color": "#6a00a3"
        },
        "notice": {
          "color": "#dda100"
        },
        "success": {
          "color": "#00865b"
        },
        "neutral": {
          "color": "#808aa3"
        }
      }
    },
    "modal": {
      "overlay": {
        "background-color": "#001647",
        "opacity": "0.4"
      },
      "dialog": {
        "size": {
          "full": {
            "max-width": "100%"
          },
          "large": {
            "max-width": "864px"
          },
          "small": {
            "max-width": "576px"
          }
        },
        "padding": "32px",
        "margin": "16px",
        "radius": "24px",
        "box-shadow": "0px 8px 16px rgba(11, 19, 74, 0.1), 0px 16px 32px rgba(11, 19, 74, 0.08), 0px 32px 64px rgba(11, 19, 74, 0.06)",
        "background-color": "#f2f3f6"
      },
      "close": {
        "top": "16px",
        "right": "16px"
      },
      "header": {
        "margin-top": "24px"
      },
      "body": {
        "desktop": {
          "margin-top": "24px"
        },
        "mobile": {
          "margin-top": "16px"
        }
      },
      "footer": {
        "margin-top": "32px"
      },
      "mobile": {
        "padding": "24px"
      }
    },
    "pagination": {
      "button": {
        "size": "48px",
        "border-color": "#b2b9c8",
        "border-radius": "8px",
        "color": {
          "rest": "#001647",
          "selected": "#0c29d0"
        },
        "background-color": {
          "rest": "#f2f3f6",
          "hover": "#e5e8ed",
          "active": "#b2b9c8",
          "selected": "#abc6ff",
          "disabled": "#f2f3f6"
        }
      }
    },
    "popover": {
      "variation": {
        "primary": {
          "color": "#364ef7"
        },
        "danger": {
          "color": "#e64c2d"
        },
        "info": {
          "color": "#af38ef"
        },
        "notice": {
          "color": "#edad00"
        },
        "success": {
          "color": "#0dc78b"
        },
        "neutral": {
          "color": "#b2b9c8"
        }
      }
    },
    "progressbar": {
      "height": "8px",
      "background-color": "#e5e8ed",
      "width": "100%",
      "border-radius": "8px",
      "variation": {
        "primary": {
          "background-color": "#0c29d0"
        },
        "success": {
          "background-color": "#00865b"
        }
      }
    },
    "progresscircle": {
      "size": {
        "small": "32px",
        "medium": "40px",
        "large": "104px"
      },
      "variation": {
        "primary": "#0c29d0",
        "success": "#00865b",
        "danger": "#d23718",
        "info": "#6a00a3",
        "notice": "#dda100",
        "neutral": "#808aa3"
      }
    },
    "radio": {
      "size": "20px",
      "border-width": "2px",
      "radius": "50%",
      "dot": {
        "size": "8px",
        "background-color": "#f2f3f6"
      },
      "errorMessage": {
        "color": "#4d5c7e"
      },
      "background-color": {
        "rest": "#f2f3f6",
        "disabled": "#e5e8ed",
        "hover": "#e5e8ed",
        "focus": "#e5e8ed",
        "active": "#b2b9c8",
        "selected": "#0c29d0",
        "selectedDisabled": "#b2b9c8",
        "error": "#ff9a86",
        "errorHover": "#ff9a86",
        "errorSelected": "#d23718"
      },
      "border-color": {
        "rest": "#b2b9c8",
        "focus": "#808aa3",
        "active": "#b2b9c8",
        "selected": "#0c29d0",
        "selectedDisabled": "#b2b9c8",
        "error": "#d23718",
        "errorSelected": "#d23718"
      },
      "box-shadow": {
        "disabled": "none",
        "hover": "0 0 0 8px #e5e8ed",
        "focus": "0 0 0 8px #e5e8ed",
        "active": "0 0 0 8px #e5e8ed",
        "errorHover": "0 0 0 8px #e5e8ed"
      },
      "label": {
        "color": {
          "rest": "#001647",
          "disabled": "#808aa3"
        },
        "font-size": "16px",
        "font-weight": "400",
        "margin-left": "8px"
      }
    },
    "steps": {
      "line": {
        "done": {
          "background-color": "#0c29d0"
        },
        "todo": {
          "background-color": "#b2b9c8"
        }
      },
      "wrapper-items": {
        "padding": {
          "left": "8px",
          "right": "16px"
        }
      },
      "done": {
        "bullet": {
          "color": "#0c29d0"
        }
      },
      "active": {
        "background-color": "#0c29d0",
        "color": "#f2f3f6",
        "border-radius": "9999px",
        "bullet": {
          "color": "#0c29d0"
        }
      },
      "todo": {
        "opacity": 0.6
      },
      "bullet": {
        "background-color": "#f2f3f6",
        "border-radius": "50%",
        "border-color": "#b2b9c8",
        "etc": {
          "color": "#0c29d0"
        }
      }
    },
    "table": {
      "desktop": {
        "radius": "12px",
        "border-width": "1px",
        "border-color": "#b2b9c8",
        "column": {
          "min-width": "120px"
        },
        "heading": {
          "padding": "8px 16px",
          "font-size": "14px",
          "font-weight": "700",
          "line-height": "24px",
          "color": "#001647"
        },
        "cell": {
          "font-size": "16px",
          "font-weight": "400",
          "line-height": "24px",
          "color": "#4d5c7e",
          "padding": "8px 16px"
        },
        "detailedContentCell": {
          "padding": "4px 8px"
        },
        "detailedContent": {
          "padding": "12px 24px"
        }
      },
      "mobile": {
        "radius": "12px",
        "border-width": "1px",
        "border-color": "#b2b9c8",
        "cell": {
          "margin-bottom": "16px",
          "color": "#4d5c7e"
        },
        "heading": {
          "margin-bottom": "4px"
        },
        "card": {
          "padding": "8px 16px 16px"
        },
        "detailedContent": {
          "padding-top": "16px"
        }
      }
    },
    "text": {
      "color": "#001647",
      "bold": "700",
      "title": {
        "large": {
          "desktop": {
            "fontSize": "40px",
            "lineHeight": "56px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "28px",
            "lineHeight": "36px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "26px",
            "lineHeight": "36px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        }
      },
      "sectionHeading": {
        "large": {
          "desktop": {
            "fontSize": "32px",
            "lineHeight": "44px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "24px",
            "lineHeight": "32px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "24px",
            "lineHeight": "32px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "18px",
            "lineHeight": "24px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        }
      },
      "sectionSubheading": {
        "large": {
          "desktop": {
            "fontSize": "26px",
            "lineHeight": "36px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "20px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        }
      },
      "detailedSubheading": {
        "large": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "24px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        }
      },
      "paragraphLg": {
        "large": {
          "desktop": {
            "fontSize": "24px",
            "lineHeight": "36px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "17px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        }
      },
      "paragraphMd": {
        "large": {
          "desktop": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "15px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        }
      },
      "caption": {
        "large": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "14px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "13px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "Plus Jakarta Sans"
          }
        }
      },
      "overlineLg": {
        "large": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "32px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "22px",
            "lineHeight": "32px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "Plus Jakarta Sans"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "Plus Jakarta Sans"
          }
        }
      },
      "overlineMd": {
        "large": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "Plus Jakarta Sans"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "Plus Jakarta Sans"
          },
          "mobile": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "Plus Jakarta Sans"
          }
        }
      }
    },
    "textarea": {
      "mobile": {
        "font-size": "13px",
        "margin": {
          "label": "4px"
        },
        "font-weight": "700"
      },
      "optionallabel": {
        "color": "#808aa3",
        "font-size": "16px",
        "font-style": "italic",
        "margin": "8px"
      },
      "padding": "16px",
      "margin": "8px",
      "helper-text": {
        "color": "#4d5c7e"
      },
      "border-color": "#b2b9c8",
      "font-family": "Plus Jakarta Sans",
      "font-size": {
        "desktop": "16px",
        "mobile": "15px"
      },
      "line-height": "24px",
      "color": "#001647",
      "background-color": "#f2f3f6",
      "radius": "8px",
      "disabled": {
        "background": "#e5e8ed",
        "border-color": "#e5e8ed"
      },
      "focused": {
        "border-color": "#0c29d0"
      },
      "placeholder": {
        "color": "#808aa3"
      },
      "feedback": {
        "error": {
          "border-color": "#d23718"
        }
      },
      "readOnly": {
        "background": "#e5e8ed"
      },
      "suprefix": {
        "margin": "12px",
        "color": "#4d5c7e",
        "paragraph": {
          "color": "#808aa3",
          "line-height": "24px",
          "font-size": "15px"
        },
        "feedback-icon": {
          "margin-left": "12px",
          "error": {
            "color": "#d23718"
          },
          "valid": {
            "color": "#00865b"
          }
        }
      }
    },
    "timeline": {
      "variation": {
        "primary": "#0c29d0",
        "danger": "#d23718",
        "info": "#6a00a3",
        "notice": "#dda100",
        "success": "#00865b",
        "neutral": "#808aa3"
      },
      "orientation": {
        "vertical": {
          "afterWidth": "1px",
          "afterHeight": "100%",
          "afterTransform": "translateY(-50%) translateX(-0.5px)",
          "justifyBefore": "flex-end",
          "justifyAfter": "flex-start"
        },
        "horizontal": {
          "afterWidth": "100%",
          "afterHeight": "1px",
          "afterTransform": "translate(-50%, 50%)",
          "justifyBefore": "center",
          "justifyAfter": "center"
        }
      }
    },
    "toast": {
      "padding": "16px",
      "border-width": "1px",
      "radius": "8px",
      "background-color": "#f2f3f6",
      "border-color": "#b2b9c8",
      "variation": {
        "info": "#abc6ff",
        "alert": "#ff9a86",
        "success": "#0fe39f"
      },
      "box-shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)"
    },
    "toggle": {
      "spacing": {
        "inline": "4px"
      },
      "radius": "4px",
      "label": {
        "margin": "16px",
        "color": "#001647",
        "border-color": "#b2b9c8",
        "radius": "9999px",
        "padding": "4px"
      },
      "styles": {
        "success": {
          "checked": {
            "background": "#00865b"
          }
        },
        "danger": {
          "checked": {
            "background": "#d23718"
          }
        }
      },
      "states": {
        "rest": {
          "background": "#b2b9c8",
          "thumb": {
            "background": "#f2f3f6",
            "radius": "50%",
            "shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)"
          }
        },
        "disabled": {
          "color": "#808aa3",
          "background": "#e5e8ed",
          "thumb": {
            "background": "#b2b9c8"
          }
        }
      },
      "hover": {
        "background": "#e5e8ed"
      },
      "focus": {
        "background": "#e5e8ed"
      }
    },
    "tooltip": {
      "font-family": "Plus Jakarta Sans",
      "font-size": "16px",
      "line-height": "20px",
      "shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
      "radius": "8px",
      "padding": "8px 16px",
      "max-width": "320px",
      "variations": {
        "default": {
          "background-color": "#0b134a",
          "color": "#f2f3f6",
          "extraContentColor": "#b2b9c8",
          "border-color": "transparent"
        },
        "inverted": {
          "background-color": "#f2f3f6",
          "color": "#001647",
          "extraContentColor": "#808aa3",
          "border-color": "#b2b9c8"
        }
      }
    }
  },
  "template": {
    "loading": {
      "circle-top-layer-color": "#0c29d0"
    }
  }
};